import ActionHelper from '@module/redux-actions';
import Analytics from '@module/analytics';
import Timers from '@module/timers';

import Router from '@module/router';

import API from '@app/api';
import Notification from '@app/store/action/notification';
import NotificationActions from '@app/store/action/notification';
import Pending from '@app/store/action/pending';
import TransferActions from '@app/store/action/transfer';
import UserActions from '@app/store/action/user';

export const actions = ActionHelper.types([
  'TRANSFERS_SUCCESS',
  'GET_TRANSFER_SUCCESS',
  'DOWNLOAD_TRANSFER_SUCCESS',

  'TRANSFERS_RESET_LIST_LOADED',
  'TRANSFERS_RESET_TRANSFER',
]);

export default ActionHelper.generate({
  list(accountId) {
    const pendingId = 'retrieveTransferList';
    return async (dispatch, getState) => {
      // Measure how long it takes to load this list
      Timers.start('transfers.load');

      if (!getState().transfers.list) {
        dispatch(Pending.setPending(pendingId));
      }

      try {
        const response = await API.Transfers.getTransfers({
          account_id: accountId,
        });

        dispatch({
          type: actions.TRANSFERS_SUCCESS,
          list: response.body || [],
        });

        // FIXME: I shouldn't be here
        Analytics.trackGoogleEvent({
          category: 'Transfers Page',
          action: 'List Loaded',
          label: Timers.stop('transfers.load'),
        });
      } catch (error) {
        if (error.body && error.body.error) {
          dispatch(Notification.setNotification('error', error.body.error));

          // FIXME: I shouldn't be here
          Analytics.trackGoogleEvent({
            category: 'Transfers Page',
            action: 'List Loading Failed',
            label: Timers.stop('transfers.load'),
          });
        } else {
          dispatch(
            Notification.setNotification(
              'error',
              'retrieve_transferlist_exception'
            )
          );

          // FIXME: I shouldn't be here
          Analytics.trackGoogleEvent({
            category: 'Transfers Page',
            action: 'List Loading Failed',
            label: Timers.stop('transfers.load'),
          });
        }
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  getTransfer(id) {
    const pendingId = 'retrieveTransfer_' + id;

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      // Let's try this, send request to the API.
      try {
        const response = await API.Transfers.getTransfer(null, {
          pathExtValues: {
            transferId: id,
          },
        });

        dispatch({
          type: actions.GET_TRANSFER_SUCCESS,
          transfer: response.body || false,
        });
      } catch (error) {
        const message =
          error.body && error.body.error
            ? error.body.error
            : 'retrieve_transfer_exception';

        Router.navigateTo('/transfers');
        dispatch(Notification.setNotification('error', message));
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  deleteTransfer({ id, account }) {
    const pendingId = 'deleteTransfer';

    return async (dispatch, getState) => {
      const { transfer, transfers } = getState();
      dispatch(Pending.setPending(pendingId));

      try {
        await API.Transfers.deleteMultipleTransfers({
          xfer_ids: [id],
          account_id: account.id,
        });

        // Let's be optimistic. The removals we just did are async, so actually there is a chance
        // they are still active on the server. So let's just remove them from our own store for now
        // and hope that the user doesn't do a refresh before they are - really - removed from the server.
        const list = transfers.list.filter((transfer) => id !== transfer.id);

        dispatch({ type: actions.TRANSFERS_SUCCESS, list });
        dispatch(
          Notification.setNotification(
            'notification',
            'delete_transfer_success'
          )
        );
        dispatch(UserActions.getUser());

        if (transfer.state === 'finished' && transfer.parent_id === id) {
          dispatch(NotificationActions.clearTransfer());
          dispatch(TransferActions.createSimilar());
        }
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'delete_transfer_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  deleteMultipleTransfers(ids = [], accountId) {
    const pendingId = 'deleteMultipleTransfers';
    return async (dispatch, getState) => {
      dispatch(Pending.setPending(pendingId));

      try {
        await API.Transfers.deleteMultipleTransfers({
          xfer_ids: ids,
          account_id: accountId,
        });

        // Let's be optimistic. The removals we just did are async, so actually there is a chance
        // they are still active on the server. So let's just remove them from our own store for now
        // and hope that the user doesn't do a refresh before they are - really - removed from the server.
        const list = getState().transfers.list.filter(
          (transfer) => ids.indexOf(transfer.id) === -1
        );

        dispatch({ type: actions.TRANSFERS_SUCCESS, list });
        dispatch(
          Notification.setNotification(
            'notification',
            'delete_transfers_success'
          )
        );
        dispatch(UserActions.getUser());
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'delete_transfers_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  updateExpiry(id, date = '') {
    const pendingId = 'expiryUpdate';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        await API.Transfers.updateTransfer(
          { delete_after: date },
          {
            pathExtValues: {
              transferId: id,
            },
          }
        );

        await dispatch(this.getTransfer(id));

        dispatch(
          Notification.setNotification('notification', 'update_expiry_success')
        );
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'update_expiry_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  resetListLoaded: [actions.TRANSFERS_RESET_LIST_LOADED],
  resetTransfer: [actions.TRANSFERS_RESET_TRANSFER],
});
